import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ArchiveIcon from '@material-ui/icons/Archive';
import SignIcon from '@material-ui/icons/Create';
import DashboardIcon from '@material-ui/icons/Dashboard';
import NewsIcon from '@material-ui/icons/EventNote';
import RegisterIcon from '@material-ui/icons/HowToReg';
import ApplicationsIcon from '@material-ui/icons/Inbox';
import EmployeeManagementIcon from '@material-ui/icons/People';
import LoginIcon from '@material-ui/icons/VpnKey';
import PropTypes from 'prop-types';
import React from 'react';
import * as con from '../utils/constants';

/**
 * Renders a custom icon button.
 *
 * @param {props} props - The icon button properties.
 * @return {React.Fragment} - The customized icon button to render.
 */
export default function NavIconButton(props: props) {
  const renderIcon = () => {
    switch (props.nav) {
      case con.NAV_SELECT_NEWS:
        return <NewsIcon />;
      case con.NAV_SELECT_HOME:
        return <DashboardIcon />;
      case con.NAV_SELECT_APPLICATIONS:
        return <ApplicationsIcon />;
      case con.NAV_SELECT_EMPLOYEE:
        return <EmployeeManagementIcon />;
      case con.NAV_SELECT_REGISTER:
        return <RegisterIcon />;
      case con.NAV_SELECT_ARCHIVE:
        return <ArchiveIcon />;
      case con.NAV_SELECT_SIGNER:
        return <SignIcon />;
      case con.NAV_SELECT_LOGIN:
        // TODO: not used yet
        return <LoginIcon />;
      default:
        return null;
    }
  };

  const handleOnClick = () => {
    if (props.nav === con.NAV_SELECT_LOGIN) {
      // TODO: not used yet
      props.onClick();
    } else {
      props.onClick(props.nav);
    }
  };

  return (
    <React.Fragment>
      <Tooltip title={props.label} placement='top'>
        <IconButton
          aria-label={props.label}
          aria-haspopup={false}
          onClick={() => handleOnClick()}
          component={props.component}
          to={props.nav}
          style={{color: props.color}}
        >
          {renderIcon()}
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
}

NavIconButton.propTypes = {
  color: PropTypes.string.isRequired,
  component: PropTypes.object,
  label: PropTypes.string.isRequired,
  nav: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
